// Backoffice
import BackofficeLayout from '@/components/layouts/BackofficeLayout'

// UI
import FulfillmentsTable from '@/components/fulfillments/FulfillmentsTable'
import Breadcrumbs from '@/components/ui/Breadcrumbs'

export default function IndexFulfillmentOrders() {
    const layoutProps = {
        breadcrumbs: [
            {
                label: 'Préparations effectuées',
            },
        ],
    }

    return (
        <div>
            <Breadcrumbs {...layoutProps} />
            <FulfillmentsTable />
        </div>
    )
}
